export default function FlooringTypesElPaso() {
  const flooringTypes = [
    {
      name: 'Hardwood Flooring',
      description: 'Classic and timeless, hardwood adds warmth and value to El Paso homes. Oak, maple, and hickory are popular choices that withstand the dry climate.',
      bestFor: 'Living rooms, dining rooms, bedrooms',
      image: 'https://public.readdy.ai/ai/img_res/ebd0ef1280dfa1ffb8f3deea31bc3e76.jpg'
    },
    {
      name: 'Luxury Vinyl Plank',
      description: 'Waterproof and durable, LVP mimics hardwood at a fraction of the cost. Perfect for El Paso\'s climate with superior moisture resistance.',
      bestFor: 'Kitchens, bathrooms, basements, entire homes',
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20vinyl%20plank%20flooring%20in%20contemporary%20kitchen%2C%20realistic%20wood-look%20waterproof%20planks%20with%20textured%20surface%2C%20stylish%20gray-toned%20LVP%20installation%20showing%20durability%20and%20easy%20maintenance%2C%20professional%20flooring%20demonstrating%20quality%20vinyl%20plank%20craftsmanship%20in%20bright%20clean%20space&width=600&height=400&seq=flooring-type-002&orientation=landscape'
    },
    {
      name: 'Tile Flooring',
      description: 'Ceramic and porcelain tiles offer unmatched durability and style. Ideal for El Paso\'s hot climate with excellent heat resistance and easy cleaning.',
      bestFor: 'Kitchens, bathrooms, entryways, patios',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20porcelain%20tile%20flooring%20in%20modern%20bathroom%2C%20large%20format%20tiles%20with%20subtle%20marble%20pattern%2C%20professional%20tile%20installation%20with%20precise%20grout%20lines%2C%20luxury%20bathroom%20interior%20showcasing%20beautiful%20ceramic%20tile%20work%20with%20clean%20contemporary%20design%20and%20flawless%20craftsmanship&width=600&height=400&seq=flooring-type-003&orientation=landscape'
    },
    {
      name: 'Carpet Flooring',
      description: 'Soft and comfortable underfoot, carpet provides insulation and noise reduction. Stain-resistant options work well in El Paso\'s low-humidity environment.',
      bestFor: 'Bedrooms, family rooms, stairs',
      image: 'https://readdy.ai/api/search-image?query=Plush%20carpet%20flooring%20in%20cozy%20bedroom%2C%20soft%20neutral%20beige%20carpet%20with%20thick%20comfortable%20pile%2C%20professional%20carpet%20installation%20showing%20smooth%20seams%20and%20proper%20stretching%2C%20inviting%20bedroom%20interior%20with%20quality%20carpeting%20creating%20warm%20comfortable%20atmosphere%20and%20sound%20insulation&width=600&height=400&seq=flooring-type-004&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Popular Flooring Options in El Paso
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the best flooring materials for El Paso homes, designed to withstand our unique desert climate
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {flooringTypes.map((type, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="h-64 w-full overflow-hidden">
                <img
                  src={type.image}
                  alt={type.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {type.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {type.description}
                </p>
                <div className="flex items-start gap-2 bg-teal-50 p-4 rounded-lg">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Best For:</strong>
                    <p className="text-gray-700 text-sm">{type.bestFor}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
